"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTerminalOnlineReducer = exports.createTerminalOnlineReducer = exports.fetchTerminalOnlineReducer = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const terminalOnlineAction_1 = require("./terminalOnlineAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchSlice = (0, toolkit_1.createSlice)({
    name: 'terminalOnline/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(terminalOnlineAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(terminalOnlineAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(terminalOnlineAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
const createTerminalSlice = (0, toolkit_1.createSlice)({
    name: 'terminalOnline/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(terminalOnlineAction_1.create.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(terminalOnlineAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(terminalOnlineAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
const updateSlice = (0, toolkit_1.createSlice)({
    name: 'terminalOnline/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(terminalOnlineAction_1.update.pending, (state) => {
            state.loading = true;
            state.data = [];
            state.error = null;
        })
            .addCase(terminalOnlineAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        })
            .addCase(terminalOnlineAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.data = [];
            state.error = action.error.message;
        });
    }
});
exports.fetchTerminalOnlineReducer = fetchSlice.reducer;
exports.createTerminalOnlineReducer = createTerminalSlice.reducer;
exports.updateTerminalOnlineReducer = updateSlice.reducer;
